import request from '@/utils/request'

/**
 * 获取用户
 */
function getPagelist(data) {
  return request({
    url: '/appUser/list',
    method: 'post',
    data
  })
}
/**
 * 禁用用户and启用用户
 * @param {*} data
 */
function resetStatus(url,params) {
  return request({
    url,
    method: 'PATCH',
    params
  })
}
/**
 * 重设密码
 * @param {*} data
 */
function resetPassword(id) {
  return request({
    url: `/appUser/resetPwd/${id}`,
    method: 'PATCH'
  })
}
/**
 * 获取用户车辆
 */
function getCarlist(id) {
  return request({
    url: `/appUser/list/car/${id}`,
    method: 'post'
  })
}
/**
 * 获取用户通知
 */
function getNotifylist(id) {
  return request({
    url: `/appUser/list/notify/${id}`,
    method: 'post'
  })
}
/**
 * 导出
 * @param {*} data
 */
function exprotHandle(data) {
  return request({
    url: '/appUser/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

/**
 * 获取绑定/解绑日志
 */
function getDisableLog(id) {
  return request({
    url: `/appUser/disable/list/${id}`,
    method: 'post'
  })
}

export {
  getPagelist,
  exprotHandle,
  resetStatus,
  resetPassword,
  getCarlist,
  getNotifylist,
  getDisableLog
}
